<template>
  <div>
    <div class="md-layout">
      <div class="md-layout-item">
        <form>
          <md-card class="p-25">
            <md-card-content>
              <div class="md-layout">
                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <model-list-select
                    class="input-must-rtl"
                    :list="employeesList"
                    v-model="employeeId"
                    option-value="key"
                    option-text="value"
                    placeholder="الموظف"
                  >
                  </model-list-select>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 ml-15 mt-25"
                >
                  <md-datepicker :md-open-on-focus="false" v-model="day">
                    <label class="mr-28">اليوم</label>
                  </md-datepicker>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 mt-25 ml-15"
                >
                  <md-field>
                    <label>الخصم من ساعات الحضور</label>

                    <md-select v-model="applyAttendanceDeduction">
                      <md-option :value="true">نعم</md-option>
                      <md-option :value="false">لا</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div class="md-layout-item md-size-30 md-small-size-100">
                  <form-time
                    v-model="leavingStart"
                    class="form-date"
                    placeholder="وقت بداية الخروج"
                    label
                  />
                </div>

                <div class="md-layout-item md-size-30 md-small-size-100 ml-15">
                  <form-time
                    v-model="leavingEnd"
                    class="form-date"
                    placeholder="وقت نهاية الخروج"
                    label
                  />
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 mt-25 ml-15"
                >
                  <md-field>
                    <label>الحالة</label>

                    <md-select v-model="isConfirmed">
                      <md-option :value="true">معتمد</md-option>
                      <md-option :value="false">غير معتمد</md-option>
                    </md-select>
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 mt-25 ml-15"
                >
                  <md-field>
                    <label>حالة الاذن</label>

                    <md-select v-model="leavePermissionStatus" disabled>
                      <md-option :value="1">فعال</md-option>
                      <md-option :value="2">منتهي</md-option>
                    </md-select>
                  </md-field>
                </div>
                <div
                  class="md-layout-item md-size-30 md-small-size-100 mt-25 mt-25 ml-15"
                >
                  <md-field>
                    <label>مدة الاذن</label>

                    <md-input v-model="leavePermissionDuration" disabled />
                  </md-field>
                </div>

                <div
                  class="md-layout-item md-size-100 mt-25 mtb-25 center-content"
                >
                  <md-button @click="search" class="md-info btn_nanosoft ml-10">
                    بحث
                  </md-button>
                  <md-button
                    @click="savePermission"
                    class="md-success btn_nanosoft ml-10"
                  >
                    حفظ
                  </md-button>
                  <md-button
                    @click="resetForm"
                    class="md-primary btn_nanosoft ml-10"
                  >
                    جديد
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </form>
      </div>
    </div>

    <div class="md-layout-item">
      <md-card>
        <md-card-content>
          <md-progress-bar
            v-if="isLoading"
            md-mode="indeterminate"
          ></md-progress-bar>

          <div class="md-layout flex-content-left">
            <div class="md-size-15 md-layout-item">
              <md-table>
                <md-table-toolbar>
                  <md-field>
                    <label for="pages">عدد النتائج</label>
                    <md-select v-model="pagination.perPage" name="pages">
                      <md-option
                        v-for="item in pagination.perPageOptions"
                        :key="item"
                        :label="item"
                        :value="item"
                        >{{ item }}</md-option
                      >
                    </md-select>
                  </md-field>
                </md-table-toolbar>
              </md-table>
            </div>
          </div>

          <div v-show="tableData.length > 0" class="md-layout">
            <div class="md-layout-item md-size-100 center-content">
              <md-button @click="bulkApprove" class="md-success btn_nanosoft ml-10"
                >اعتماد</md-button
              >
              <md-button @click="bulkUnapprove" class="md-danger btn_nanosoft ml-10"
                >إلغاء الاعتماد</md-button
              >
            </div>
          </div>
          <div v-show="tableData.length > 0" class="select-all-header">
            <md-checkbox @change="selectAll" v-model="All"
              >اختيار الكل</md-checkbox
            >
          </div>
          <template>
            <md-table
              :value="queriedData"
              :md-sort.sync="currentSort"
              :md-sort-order.sync="currentSortOrder"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
            >
              <md-table-row slot="md-table-row" slot-scope="{ item }">
                <md-table-cell>
                  <md-checkbox
                    v-model="item.isActive"
                    @change="add(item)"
                  ></md-checkbox>
                </md-table-cell>

                <md-table-cell md-label="اسم الموظف">
                  {{ item.employeeName }}
                </md-table-cell>

                <md-table-cell md-label="اليوم">
                  {{ convert(item.day) }}
                </md-table-cell>

                <md-table-cell md-label="وقت بداية الخروج">
                  {{ item.leavingStart }}
                </md-table-cell>

                <md-table-cell md-label="وقت نهاية الخروج">
                  {{ item.leavingEnd }}
                </md-table-cell>

                <md-table-cell md-label="الحالة">
                  <span
                    :class="item.isConfirmed ? 'text-success' : 'text-danger'"
                  >
                    {{ item.isConfirmed ? "معتمد" : "غير معتمد" }}
                  </span>
                </md-table-cell>

                <md-table-cell md-label="إجراءات">
                  <div>
                    <md-button
                      v-if="!item.isConfirmed"
                      @click="approvePermission(item)"
                      class="md-icon-button md-raised md-success btn_nanosoft"
                    >
                      <md-icon>check_circle</md-icon>
                    </md-button>
                    <md-button
                      v-if="item.isConfirmed"
                      @click="cancelApproval(item)"
                      class="md-icon-button md-raised md-default btn_nanosoft"
                    >
                      <md-icon>cancel</md-icon>
                    </md-button>
                    <md-button
                      @click="editPermission(item)"
                      class="md-icon-button md-raised md-warning btn_nanosoft"
                    >
                      <md-icon>edit</md-icon>
                    </md-button>
                    <md-button
                      @click="deletePermission(item)"
                      class="md-icon-button md-raised md-danger btn_nanosoft"
                    >
                      <md-icon>delete</md-icon>
                    </md-button>
                  </div>
                </md-table-cell>
              </md-table-row>
            </md-table>
          </template>
        </md-card-content>
        <md-card-actions md-alignment="space-between">
          <div class>
            <p class="card-category">
              Showing {{ fromPage + 1 }} to {{ toPage }} of {{ total }} entries
            </p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { ModelListSelect } from "vue-search-select";
import { Pagination } from "@/components";
import moment from "moment";

export default {
  mounted() {
    this.getPermissions();
  },
  components: {
    ModelListSelect,
    Pagination,
  },
  computed: {
    leavePermissionDuration() {
      if (!this.leavingStart || !this.leavingEnd) {
        return "00:00";
      }

      const start = moment(this.leavingStart, "HH:mm");
      const end = moment(this.leavingEnd, "HH:mm");

      if (!start.isValid() || !end.isValid()) {
        return "00:00";
      }

      let diff = end.diff(start);
      if (diff < 0) {
        diff += 24 * 60 * 60 * 1000;
      }
      const duration = moment.duration(diff);
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();

      return `${hours.toString().padStart(2, "0")}:${minutes
        .toString()
        .padStart(2, "0")}`;
    },
    employeesList() {
      const lists = this.$store.getters["global/employeesData"];
      return lists?.employees || [];
    },
    queriedData() {
      return this.tableData;
    },
    toPage() {
      let highBound = this.fromPage + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    fromPage() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.pagination.total;
    },
  },
  data() {
    return {
      isLoading: false,
      All: false,
      selectedPermissions: [],
      employeeId: null,
      day: null,
      isConfirmed: false,
      applyAttendanceDeduction: true,
      leavePermissionStatus: 2,
      leavingStart: null,
      leavingEnd: null,
      employees: [],
      tableData: [],
      isEditing: false,
      editingItemId: null,
      pagination: {
        perPage: 25,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
      },
      currentSort: "day",
      currentSortOrder: "asc",
    };
  },
  methods: {
    selectAll(event) {
      if (event) {
        this.selectedPermissions = this.tableData.map((item) => item.id);
        this.tableData.forEach((item) => {
          this.$set(item, "isActive", true);
        });
      } else {
        this.selectedPermissions = [];
        this.tableData.forEach((item) => {
          this.$set(item, "isActive", false);
        });
      }
    },
    add(item) {
      if (item.isActive) {
        if (!this.selectedPermissions.includes(item.id)) {
          this.selectedPermissions = [...this.selectedPermissions, item.id];
        }
      } else {
        this.selectedPermissions = this.selectedPermissions.filter(
          (f) => f != item.id
        );
      }
    },
    async bulkApprove() {
      if (this.selectedPermissions.length === 0) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "يرجى تحديد إذن واحد على الأقل"
        );
      }
      try {
        this.isLoading = true;

        const schema = {
          selectedPermissions: this.selectedPermissions,
        };

        const { data } = await this.$axios.patch(
          `/api/leavePermission/confirm`,
          schema
        );

        if (data.message) {
          this.notifyVue("top", "center", "success", data.message);
        }
        this.selectedPermissions = [];
        this.All = false;
        this.fetchData();
      } catch (error) {
        this.notifyVue("top", "center", "danger", "حدث خطأ أثناء اعتماد الأذونات");
      } finally {
        this.isLoading = false;
      }
    },
    async bulkUnapprove() {
      if (this.selectedPermissions.length === 0) {
        return this.notifyVue(
          "top",
          "center",
          "warning",
          "يرجى تحديد إذن واحد على الأقل"
        );
      }
      try {
        this.isLoading = true;

        const schema = {
          selectedPermissions: this.selectedPermissions,
        };

        const { data } = await this.$axios.patch(
          `/api/leavePermission/unconfirm`,
          schema
        );

        if (data.message) {
          this.notifyVue("top", "center", "success", data.message);
        }
        this.selectedPermissions = [];
        this.All = false;
        this.fetchData();
      } catch (error) {
        this.notifyVue(
          "top",
          "center",
          "danger",
          "حدث خطأ أثناء إلغاء اعتماد الأذونات"
        );
      } finally {
        this.isLoading = false;
      }
    },
    async search() {
      try {
        if (!this.employeeId) {
          return this.notifyVue(
            "top",
            "center",
            "danger",
            "يرجى اختيار الموظف"
          );
        }

        this.isLoading = true;

        const params = {
          employeeId: this.employeeId,
          day: this.day,
          leavingStart: this.leavingStart,
          leavingEnd: this.leavingEnd,
          applyAttendanceDeduction: this.applyAttendanceDeduction,
          leavePermissionStatus: this.leavePermissionStatus,
          pageSize: this.pagination.perPage,
          CurrentPage: this.pagination.currentPage,
        };

        const { data } = await this.$axios.get("/api/leavePermission", {
          params,
        });
        this.tableData = (data.data.results || []).map((item) => ({
          ...item,
          isActive: false,
        }));
        this.pagination.total = data.data.total;
      } catch (error) {
        this.notifyVue("top", "center", "danger", "حدث خطأ أثناء البحث");
      } finally {
        this.isLoading = false;
      }
    },
    async getPermissions() {
      try {
        this.isLoading = true;
        const { data } = await this.$axios.get("/api/leavePermission", {
          params: {
            pageSize: this.pagination.perPage,
            CurrentPage: this.pagination.currentPage,
          },
        });
        this.tableData = (data.data.results || []).map((item) => ({
          ...item,
          isActive: false,
        }));
        this.pagination.total = data.data.total;
      } catch (error) {
        this.notifyVue("top", "center", "danger", "حدث خطأ أثناء جلب البيانات");
      } finally {
        this.isLoading = false;
      }
    },
    resetForm() {
      this.employeeId = null;
      this.day = null;
      this.leavingStart = null;
      this.leavingEnd = null;
      this.isConfirmed = false;
      this.isEditing = false;
      this.editingItemId = null;
      this.applyAttendanceDeduction = null;
      this.leavePermissionStatus = null;

      this.getPermissions();
    },

    validateForm() {
      if (!this.employeeId) {
        return this.notifyVue("top", "center", "danger", "يرجى اختيار الموظف");
      }

      if (!this.day) {
        return this.notifyVue("top", "center", "danger", "يرجى اختيار اليوم");
      }

      if (!this.leavingStart || !this.leavingEnd) {
        return this.notifyVue(
          "top",
          "center",
          "danger",
          "يرجى اختيار وقت بداية ونهاية الخروج"
        );
      }

      return true;
    },

    async savePermission() {
      try {
        const validate = this.validateForm();

        if (!validate) {
          return;
        }

        this.isLoading = true;

        if (this.isEditing) {
          this.updatePermission();
          return;
        }

        const schema = {
          employeeId: this.employeeId,
          day: moment(this.day).format("YYYY-MM-DD"),
          leavingStart: this.leavingStart,
          leavingEnd: this.leavingEnd,
          applyAttendanceDeduction: this.applyAttendanceDeduction,
          leavePermissionStatus: this.leavePermissionStatus,
        };

        const { data } = await this.$axios.post("/api/leavePermission", schema);
        this.notifyVue("top", "center", "success", "تم حفظ البيانات بنجاح");
        this.resetForm();
        this.getPermissions();
      } catch (error) {
        this.notifyVue("top", "center", "danger", error.response.data.message);
      } finally {
        this.isLoading = false;
      }
    },

    async updatePermission() {
      try {
        this.isLoading = true;

        const schema = {
          employeeId: this.employeeId,
          day: this.day,
          leavingStart: this.leavingStart,
          leavingEnd: this.leavingEnd,
          applyAttendanceDeduction: this.applyAttendanceDeduction,
          leavePermissionStatus: this.leavePermissionStatus,
        };

        const { data } = await this.$axios.put(
          `/api/leavePermission/${this.editingItemId}`,
          schema
        );

        this.notifyVue("top", "center", "success", "تم تحديث البيانات بنجاح");
        this.resetForm();
        this.getPermissions();
      } catch (error) {
        this.notifyVue(
          "top",
          "center",
          "danger",
          "حدث خطأ أثناء تحديث البيانات"
        );
      } finally {
        this.isLoading = false;
      }
    },

    editPermission(item) {
      this.employeeId = item.employeeId;
      this.day = moment(item.day).format("YYYY-MM-DD");
      this.leavingStart = item.leavingStart;
      this.leavingEnd = item.leavingEnd;
      this.isConfirmed = item.isConfirmed;
      this.isEditing = true;
      this.editingItemId = item.id;
      this.applyAttendanceDeduction = item.applyAttendanceDeduction;
      this.leavePermissionStatus = item.leavePermissionStatus;
    },

    async approvePermission(item) {
      try {
        this.isLoading = true;

        const schema = {
          selectedPermissions: [item.id],
        };

        const { data } = await this.$axios.patch(
          `/api/leavePermission/confirm`,
          schema
        );

        if (data.message) {
          this.notifyVue("top", "center", "success", data.message);
          this.getPermissions();
        }
      } catch (error) {
        this.notifyVue("top", "center", "danger", "حدث خطأ أثناء اعتماد الإذن");
      } finally {
        this.isLoading = false;
      }
    },

    async cancelApproval(item) {
      try {
        this.isLoading = true;

        const schema = {
          selectedPermissions: [item.id],
        };

        const { data } = await this.$axios.patch(
          `/api/leavePermission/unconfirm`,
          schema
        );

        if (data.message) {
          this.notifyVue("top", "center", "success", data.message);
          this.getPermissions();
        }
      } catch (error) {
        this.notifyVue(
          "top",
          "center",
          "danger",
          "حدث خطأ أثناء إلغاء اعتماد الإذن"
        );
      } finally {
        this.isLoading = false;
      }
    },

    async deletePermission(item) {
      Swal.fire({
        text: "سيتم الحذف هل انت متأكد ؟",
        type: "warning",
        showCancelButton: true,
        confirmButtonClass: "md-button md-success btn-fill",
        cancelButtonClass: "md-button md-danger btn-fill",
        confirmButtonText: "نعم",
        cancelButtonText: "لا",
        buttonsStyling: false,
      }).then(async (result) => {
        if (result.value) {
          try {
            this.isLoading = true;
            const { data } = await this.$axios.delete(
              `/api/leavePermission/${item.id}`
            );

            if (data.message) {
              this.notifyVue("top", "center", "success", data.message);
              this.getPermissions();
            }
          } catch (error) {
            this.notifyVue(
              "top",
              "center",
              "danger",
              "حدث خطأ أثناء حذف البيانات"
            );
          } finally {
            this.isLoading = false;
          }
        }
      });
    },

    convert(event) {
      try {
        let d = new Date(event);
        if (isNaN(d.getFullYear()) === true) {
          return "-";
        }
        return d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate();
      } catch (error) {}
    },

    notifyVue(verticalAlign, horizontalAlign, type, message, time = 10000) {
      this.$notify({
        timeout: time,
        message: message,
        icon: "add_alert",
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: type,
      });
    },

    fetchData() {
      if (this.employeeId) {
        this.search();
      } else {
        this.getPermissions();
      }
    },
    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    },
  },
  watch: {
    "pagination.perPage"() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    "pagination.currentPage"() {
      this.fetchData();
    },
  },
};
</script>

<style scoped>
.text-success {
  color: #4caf50;
}
.text-danger {
  color: #f44336;
}
.select-all-header {
  display: flex;
  align-items: center;
  padding: 0 16px;
  margin-bottom: -8px;
}
</style>
